module.exports = __webpack_public_path__ + "img/info.62fe69b7.svg";